import React, { useState, Suspense } from "react";
import { Box, Toolbar, CircularProgress } from "@mui/material";
import Header from "../common/Header";

interface LayoutProps {
  children: React.ReactNode;
}

const drawerWidth = 240;
const miniDrawerWidth = 60;

function Layouts({ children }: LayoutProps) {
  const [miniMode, setMiniMode] = useState(false);

  const handleMiniToggle = () => setMiniMode((prev) => !prev);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      {/* Header Component */}
      <Header miniMode={miniMode} handleMiniToggle={handleMiniToggle} />

      {/* Spacer for Toolbar height */}
      <Toolbar />

      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          marginLeft: { md: `${miniMode ? miniDrawerWidth : drawerWidth}px` },
          padding: "16px",
          backgroundColor: "#F5F5FC",
          transition: (theme) =>
            theme.transitions.create(["margin-left"], {
              easing: theme.transitions.easing.easeInOut,
              duration: theme.transitions.duration.standard,
            }),
          overflow: "auto",
        }}
      >
        <Suspense
          fallback={
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "400px",
                height: "100%",
              }}
            >
              <CircularProgress />
            </Box>
          }
        >
          {children}
        </Suspense>
      </Box>
    </Box>
  );
}

export default Layouts;
